export enum Transition {
  NONE = '',
  FORWARD = 'FORWARD',
  BACKWARD = 'BACKWARD',
}
